import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client';

// centralize cache creation to ensure consistent configuration
// Initialize InMemoryCache with optional configurations
export const createCache = (
  config: Omit<InMemoryCacheConfig, 'canonizeResults' | 'addTypename'> = {}
): InMemoryCache => {
  return new InMemoryCache({
    ...config,
  });
};
